import { render, staticRenderFns } from "./EditDepartment.vue?vue&type=template&id=617c0592&scoped=true"
import script from "./EditDepartment.vue?vue&type=script&lang=js"
export * from "./EditDepartment.vue?vue&type=script&lang=js"
import style0 from "./EditDepartment.vue?vue&type=style&index=0&id=617c0592&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617c0592",
  null
  
)

export default component.exports